import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import styles from './flex-container.scss.js';
export class FlexContainer extends CipublicElement {
    static get styles() {
        return [styles];
    }
    render() {
        return html `<slot></slot>`;
    }
}
//# sourceMappingURL=flex-container.js.map